import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5181066e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181066e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5181066e')) {
      api.createRecord('5181066e', component.options)
    } else {
      api.reload('5181066e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5181066e&scoped=true", function () {
      api.rerender('5181066e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectLazyLoad/index.vue"
export default component.exports